// src/utils/availableFunds.ts

import type { PortfolioPosition } from '../types/Portfolio';

export type AvailableFundsBreakdown = {
  capital: number;
  rendimiento: number;
  total: number;
};

export function computeAvailableFundsFromPositions(positions: PortfolioPosition[]): AvailableFundsBreakdown {
  const closed = Array.isArray(positions) ? positions.filter(p => p.status === 'closed') : [];
  const capital = closed.reduce((sum, p) => sum + Number(p.investedAmount || 0), 0);
  const rendimiento = closed.reduce((sum, p) => sum + Number(p.expectedReturn || 0), 0);
  const total = capital + rendimiento;
  return { capital, rendimiento, total };
}

export function getClosedProjectIds(positions: PortfolioPosition[]): number[] {
  const closed = Array.isArray(positions) ? positions.filter(p => p.status === 'closed') : [];
  const ids = closed
    .map(p => Number(p.projectId))
    .filter(n => Number.isFinite(n) && n > 0);
  return Array.from(new Set(ids));
}

export function safeParseJson<T>(value: string | null): T | null {
  if (!value) return null;
  try {
    return JSON.parse(value) as T;
  } catch {
    return null;
  }
}
